export const importDefaultOrderTypes = ["DINE_IN", "DELIVERY", "ROOM_SERVICE", "PICK_UP"];

export const importOrderDateMatchTypes = ["default", "earliest", "latest"];

// t("enums.orders.date_match_types.default")
// t("enums.orders.date_match_types.earliest")
// t("enums.orders.date_match_types.latest")
